export enum ECommissionVariant {
  DEFAULT = 'default',
  CIRCULAR = 'circular',
  LIST = 'list',
}
